import React, { useEffect, useState } from 'react';
import { v3_plan_approval_logs } from '../../../actions/v3/planApproval';
import moment from 'moment';

const Log = ({ planId }) => {
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [logs, setLogs] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const fetchLogs = async (pageNum) => {
        setLoading(true);
        try {
            const res = await v3_plan_approval_logs(planId, pageNum, limit);
            if (res.status) {
                setLogs(prev => {
                    const existingIds = new Set(prev.map(log => log.ID));
                    const newLogs = res.result.logs.filter(log => !existingIds.has(log.ID));
                    return [...prev, ...newLogs];
                });
                setTotal(res.result.total);
            }
        } catch (err) {
            console.error("Failed to load logs", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs(1); // Load first page initially
    }, [planId]);

    const handleLoadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchLogs(nextPage);
    };

    const hasMore = logs.length < total;

    return (


        <div className="activity-items">
            {logs.map((item, index) => {
                const initials = item.CREATED_BY_NAME
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase())
                    .join('');
                return (
                    <div className="activity-item-wrap activity-call" key={index}>
                        <div className="activity-item-badge">
                            <i className="aroicon-action-send-message" />
                        </div>
                        <div className="activity-item">
                            <div className="activity-item-meta">
                                <div className="activity-user">{initials}</div>
                                <p className="activity-summary">
                                    <strong>{item.CREATED_BY_NAME}</strong> {item.REMARK}
                                </p>
                                <p className="activity-timestamp">
                                    {moment(item.CREATED_ON).format('MMM DD YYYY at hh:mm a')}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })}

            {hasMore && (
                <div className="activity-item-wrap activity-date text-center mt-3">
                    <button
                        className="btn btn-outline-primary"
                        onClick={() => handleLoadMore}
                        disabled={loading}
                    >
                        {loading ? 'Loading...' : 'Load more activity...'}
                    </button>
                </div>
            )}
        </div>

    );
};

export default Log;
